import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  Box,
  Card,
  Icon,
  Link as MuiLink,
  Space,
  TextBody,
} from '@ally/metronome-ui'
import { muiWarningFill } from '@ally/metronome-icons'
import { formatAsServerDate } from '../../utils'

const StyledIcon = styled(Icon)`
  flex: none;
`

interface DataProps {
  effectiveFrom: string
  effectiveTill: string
}

const ScheduledMaintenance: React.FC<DataProps> = ({
  effectiveFrom,
  effectiveTill,
}) => {
  const from = formatAsServerDate(effectiveFrom, 'h:mm A')
  const to = formatAsServerDate(effectiveTill, 'h:mm A')

  useEffect(() => {
    window.allytm.event(
      'customError',
      `Auto accounts are unavailable every night from ${from} - ${to} ET
    while we process payments.`,
    )
  }, [])

  return (
    <Card closeButton={false}>
      <Box display="flex">
        <StyledIcon
          icon={muiWarningFill}
          size="xl"
          fill="error"
          mr="xs"
          mt="2px"
          data-testid="scheduled-maintenance-error-icon"
        />
        <Box>
          <Space mb="xs">
            <TextBody tag="p" size="sm" weight="bold">
              Auto accounts are unavailable every night from {from} – {to} ET
              while we process payments.
            </TextBody>
          </Space>
          <TextBody tag="p" size="sm">
            Come back later to log in to your account, or call{' '}
            <MuiLink
              text="1-888-925-2559"
              href="tel:18889252559"
              aria-label="1, 8 8 8, 9 2 5, 2 5 5 9"
            />{' '}
            Mon – Fri, 8 am – 11 pm ET, and Sat 9 am – 7 pm ET.
          </TextBody>
        </Box>
      </Box>
    </Card>
  )
}

export default ScheduledMaintenance
